import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { IconPointerDown } from '@alfa-bank/site-icon/pointer-down';
import { Button } from '@alfa-bank/site-button-v2';
import { ArrowPopover as Tooltip } from '@alfa-bank/site-popover/arrow-popover';
import { DataLayer } from '@alfa-bank/site-data-layer';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';

import { BannerLink } from '../banner-link';
import styles from '../../styles/styles.css';

import { ApplicationsButton as Component } from './applications-button';
import type { IDeps, TApplicationsButton } from './models';
import { IconBag } from './icon-bag';

export const ApplicationsButton = createWidget<IDeps, TApplicationsButton>({
    BannerLink,
    Button,
    DataLayer,
    IconPointerDown,
    Text,
    Tooltip,
    styles,
    IconBag,
})(Component);
